import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import image from '@/features/management/manager/assets/empty-state-after-processed.svg';
import { Button } from '@/ui/Button';

const Graphics = styled.img.attrs({ src: image })``;

const ClearButton = styled(Button).attrs({ variant: 'primary', size: 'large' })`
  margin-top: 32px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 0;
`;

const Heading = styled.h3`
  ${(p) => p.theme.typography.title3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
  margin-bottom: 8px;
`;

const Subheading = styled.span`
  ${(p) => p.theme.typography.body3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

type ManagementEmptyStateAfterProcessedProps = {
  onFiltersClear: () => void;
};

export const ManagementEmptyStateAfterProcessed = ({ onFiltersClear }: ManagementEmptyStateAfterProcessedProps): JSX.Element => {
  const { t } = useTranslation('managerDashboard');

  return (
    <Wrapper>
      <Graphics />
      <Heading>{t('empty-state-after-processed-title')}</Heading>
      <Subheading>{t('empty-state-after-processed-subtitle')}</Subheading>
      <ClearButton onClick={onFiltersClear}>{t('empty-state-clear-filters-action')}</ClearButton>
    </Wrapper>
  );
};
